import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  useAddAdministratorMutation,
  useAdministratorsQuery,
  useRemoveAdministratorMutation,
} from "../Teams.state";
import { useUserQuery } from "../../monitor/User.state";
import { CardBody } from "../../App.styles";
import TeamOnlySelect from "../TeamOnlySelect";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";

const Administrators = () => {
  const { t } = useTranslation();
  const { data: administrators, isFetching } = useAdministratorsQuery();
  const { addAdministrator } = useAddAdministratorMutation();
  const { removeAdministrator } = useRemoveAdministratorMutation();
  const user = useUserQuery();

  const handleTeamAdministratorChange = useCallback(
    async (selectedTeam) => {
      if (!selectedTeam) {
        return;
      }

      const players = selectedTeam.users || [];
      const allPlayersAdministrators = players.every((player) =>
        administrators?.some((adminPlayer) => adminPlayer.id === player.id)
      );

      if (allPlayersAdministrators) {
        for (let player of players) {
          if (administrators?.some((adminPlayer) => adminPlayer.id === player.id)) {
            await removeAdministrator(player);
          }
        }
        return;
      }

      for (let player of players) {
        if (!administrators?.some((adminPlayer) => adminPlayer.id === player.id)) {
          await addAdministrator(player);
        }
      }
    },
    [addAdministrator, administrators, removeAdministrator]
  );

  const handleAdministratorsChange = useCallback(
    async (value) => {
      for (let player of (administrators || []).filter(
        (adminPlayer) => !(value || []).find((v) => v.id === adminPlayer.id)
      )) {
        if (user?.game?.creator && user?.id === player.id) {
          continue; // Prevent removing the creator
        }
        await removeAdministrator(player);
      }
    },
    [administrators, removeAdministrator, user]
  );

  const adminList =
    user?.game?.creator && administrators && user
      ? !administrators.find((a) => a.id === user.id)
        ? administrators.concat(user)
        : administrators
      : administrators;

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t("Administrators")}</span>
      </div>
      <div className="card-body">
        <p
          dangerouslySetInnerHTML={{
            __html: t(
              "Want someone else to help manage? Add them here to give them full access."
            ),
          }}
        />
        {isFetching && administrators === undefined ? (
          <Spinner size="0.875rem" />
        ) : (
          <>
            <TeamOnlySelect
              setValue={handleTeamAdministratorChange}
              mapLabel="name"
              placeholder={t("Select team...")}
              disableClearable={true}
              loading={isFetching}
            />
            <div className="mt-2">
              <TeamSelect
                setValue={handleAdministratorsChange}
                value={adminList}
                mapLabel="email"
                placeholder={t("Select people...")}
                loading={isFetching}
                readOnly
              />
            </div>
          </>
        )}
      </div>
    </CardBody>
  );
};

export default Administrators;
